import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import LoadingButton from "../../components/LoadingButton"
import {
  toggleCreateUserDialog,
  createUser,
  getUserByPhone,
} from "../../actions/users"
import { isEmpty, isEqual, pickBy } from "lodash"
import update from "immutability-helper"
import Input from "@material-ui/core/Input"
import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import FormHelperText from "@material-ui/core/FormHelperText"
import Grid from "@material-ui/core/Grid"
import { openSnackBar } from "../../actions/snack-bar"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"
import { listCrew } from "../../actions/crew"
import {
  getUsers,
  createLocation,
  updateLocation,
  createRole,
  updateRole,
  createNote,
  updateNote,
} from "../../actions/misc"
import AutoComplete from "../AutoComplete/index"
import TextField from "@material-ui/core/TextField"
import PositionChip from "../ProfileDialog/PositionChip"
import classNames from "classnames"
import AddIcon from "@material-ui/icons/Add"
import PlacesAutoComplete from "../PlacesAutoComplete/index"
import MapCard from "../ProfileDialog/MapCard"
import { getStateCodeByStateName } from "us-state-codes"
import Switch from "@material-ui/core/Switch"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import InfoCircle from "../InfoCircle/index"
import MessageIcon from "@material-ui/icons/Message"
import CircleAvatar from "../CircleAvatar/index"
import Moment from "moment"
import PhoneInput from "../PhoneInput"
import { parseNumber } from "libphonenumber-js"
import { addUserToCompany } from "../../actions/companies"
import countryList from "country-list"

const radiusSuggestions = [
  { id: 1, name: 30 },
  { id: 2, name: 45 },
  { id: 3, name: 65 },
  { id: 4, name: 100 },
]

const c = countryList()

class CreateUserDialog extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        roles: [],
        locations: [],
        notes: [],
        public: true,
      },
      rate: "",
      role: null,
      location: {},
      radius: null,
      form: {},
      newNote: "",
      savingProfile: false,
      selectedCountry: "US",
    }
  }
  handleClose = () => {
    this.props.dispatch(toggleCreateUserDialog(false))
  }
  clearState = () => {
    this.setState({
      user: {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        roles: [],
        locations: [],
        notes: [],
        public: true,
      },
      selectedCountry: "US",
      rate: null,
      role: {},
      location: {},
      radius: null,
      newNote: "",
      savingProfile: false,
    })
  }
  setUpForm = () => {
    const form = document.getElementById("edit-form")
    const inputs = form.querySelectorAll("input, textarea")
    let newState = update(this.state, {})
    if (!newState.form) {
      newState.form = {}
    }
    for (let i = 0; i < inputs.length; ++i) {
      newState.form[inputs[i].name] = { validity: inputs[i].validity }
    }
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value
    const validity = e.target.validity

    let newState = update(this.state, {
      user: {
        [fieldName]: { $set: value },
      },
      form: {
        [fieldName]: {
          validity: { $set: validity },
        },
      },
    })
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
  }
  handlePhoneChange = value => {
    let validity = document.getElementById("phoneInput").validity
    if (value) {
      validity.phone = !isEmpty(parseNumber(value, this.state.selectedCountry))
    } else {
      validity.phone = false
    }
    let newState = update(this.state, {
      user: {
        phone: { $set: value },
      },
      form: {
        phone: {
          validity: { $set: validity },
        },
      },
    })
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
  }
  handleCountryChange = country => {
    this.setState({ selectedCountry: country })
  }
  handleInputBlur = e => {
    const fieldName = e.target.name

    let newState = update(this.state, {
      form: {
        [fieldName]: {
          touched: { $set: true },
        },
      },
    })
    this.setState(newState)
  }
  handlePhoneBlur = e => {
    this.setState(
      update(this.state, {
        form: {
          phone: {
            touched: { $set: true },
          },
        },
      })
    )
  }
  fieldIsValid = inputName => {
    if (!isEmpty(this.state.form)) {
      if (this.state.form[inputName].touched) {
        if (inputName === "phone") {
          return (
            this.state.form[inputName].validity.valid &&
            this.state.form[inputName].validity.phone
          )
        } else {
          return this.state.form[inputName].validity.valid
        }
      } else {
        return true
      }
    } else {
      return true
    }
  }
  formIsValid = form => {
    let formValidArray = []
    for (let key in form) {
      if (key !== "valid") {
        formValidArray.push(form[key].validity.valid)
      }
    }
    return formValidArray.indexOf(false) === -1
  }
  pushNote = () => {
    this.setState(
      update(this.state, {
        user: {
          notes: {
            $push: [
              {
                note: this.state.newNote,
              },
            ],
          },
        },
        newNote: {
          $set: "",
        },
      })
    )
  }

  submit = () => {
    this.setState({
      savingProfile: true,
    })
    this.props
      .dispatch(getUserByPhone(this.state.user.phone))
      .then(res => {
        this.setState({ foundUser: res })
        this.checkAddToCompany()
      })
      .catch(err => {
        if (err.status === 404) {
          this.createUser().then(res => {})
        } else {
          this.setState({
            savingProfile: false,
          })
          this.props.dispatch(
            openSnackBar({
              message: "There was an unknown error",
            })
          )
          return
        }
      })
  }
  checkAddToCompany = () => {
    if (this.state.foundUser.has_password) {
      this.props
        .dispatch(
          addUserToCompany(this.props.activeCompany, this.state.foundUser.id)
        )
        .then(() => {
          this.afterCreateOrUpdate()
        })
        .catch(err => {
          let message = "There was an error adding crew member"
          if (err.response) {
            const error = err.response.body.error
            if (error === "user already exists in company") {
              // message = "That user already exists in your company"\
              message = "That user already exists"
            }
          }
          this.setState({
            savingProfile: false,
          })
          this.props.dispatch(
            openSnackBar({
              message,
            })
          )
        })
    } else {
      const data = pickBy(this.state.user, val => !isEmpty(val))
      delete data.first_name
      delete data.last_name
      delete data.email
      delete data.phone
      let promises = []
      Object.keys(data).forEach(key => {
        switch (key) {
          case "locations":
            data[key].forEach(location => {
              let functionName = createLocation
              let params = [location, this.state.foundUser.id]
              const existingLocation = this.state.foundUser.locations.find(
                l => {
                  if (location.country === "United States") {
                    return (
                      l.city === location.city && l.state === location.state
                    )
                  } else {
                    return (
                      l.city === location.city && l.country === location.country
                    )
                  }
                }
              )
              if (existingLocation) {
                functionName = updateLocation
                params.splice(1, 0, existingLocation.id)
              }
              promises.push(this.props.dispatch(functionName(...params)))
            })
            break
          case "roles":
            data[key].forEach(role => {
              let data = role
              if (data.hasOwnProperty("className")) {
                delete data.className
                delete data.id
              }
              let functionName
              // let functionName = createRole
              let params = [data, this.state.foundUser.id]
              const existingPosition = this.state.foundUser.roles.find(
                l => l.name === data.name
              )
              if (existingPosition) {
                functionName = updateRole
                params.splice(1, 0, existingPosition.id)
              }
              promises.push(this.props.dispatch(functionName(...params)))
            })
            break
          case "notes":
            data[key].forEach(note => {
              let data = note
              let functionName = createNote
              let params = [data, this.state.foundUser.id]
              const existingNote = this.state.foundUser.notes.find(
                l => l.creator_id === this.props.authenticatedUser.id
              )
              if (existingNote) {
                functionName = updateNote
                params.splice(1, 0, existingNote.id)
              }
              promises.push(this.props.dispatch(functionName(...params)))
            })
            break
          default:
            return
        }
      })
      Promise.all(promises).finally(() => {
        this.props
          .dispatch(
            addUserToCompany(this.props.activeCompany, this.state.foundUser.id)
          )
          .then(() => {
            this.afterCreateOrUpdate()
          })
          .catch(err => {
            let message = "There was an error adding crew member"
            if (err.response) {
              const error = err.response.body.error
              if (error === "user already exists in company") {
                message = "That user already exists in your company"
              }
            }
            this.setState({
              savingProfile: false,
            })
            this.props.dispatch(
              openSnackBar({
                message,
              })
            )
          })
      })
      // this.props
      //   .dispatch(updateUser(this.state.foundUser.id, data))
      //   .then(res => {
      //     this.props
      //       .dispatch(
      //         addUserToCompany(
      //           this.props.activeCompany,
      //           this.state.foundUser.id
      //         )
      //       )
      //       .then(() => {
      //         this.afterCreateOrUpdate();
      //       });
      //   });
    }
  }
  createUser = () => {
    const data = pickBy(this.state.user, val => !isEmpty(val))
    data.countryCode = this.state.selectedCountry
    return this.props
      .dispatch(createUser({ ...data, public: this.state.user.public ? 1 : 0 }))
      .then(res => {
        if (this.props.onSaveUser) {
          this.props.onSaveUser(res)
        }
        this.props.dispatch(getUsers())
        this.props.dispatch(listCrew(1)).then(res => {
          this.afterCreateOrUpdate()
        })
      })
      .catch(err => {
        console.log(err)
        let message
        if (err === "Phone number does not exist") {
          message = err
        } else {
          message = "There was an error creating crew member"
          if (err.response) {
            const error = err.response.body.error
            if (error.code === "ER_DUP_ENTRY") {
              if (error.sqlMessage.indexOf("for key 'phone'") > -1) {
                message = "That phone number is already in use"
              }
            }
          }
        }
        this.setState({
          savingProfile: false,
        })
        this.props.dispatch(
          openSnackBar({
            message,
          })
        )
      })
  }
  afterCreateOrUpdate = () => {
    this.setState({
      savingProfile: false,
    })
    this.props.dispatch(
      openSnackBar({
        message: "Crew member created",
      })
    )
    this.handleClose()
    this.props.onCreateUser && this.props.onCreateUser()
  }
  onAutoCompleteChange = async val => {
    await this.setState(
      update(this.state, {
        role: {
          $set: this.props.roles.find(n => n.id === val),
        },
      })
    )
    // document.getElementById("rate-input").focus()
  }
  savePosition = async e => {
    e.preventDefault()
    let data = { ...this.state.role, rate: this.state.rate }
    if (data.hasOwnProperty("className")) {
      delete data.className
      delete data.id
    }

    await this.setState(
      update(this.state, {
        user: {
          roles: {
            $push: [data],
          },
        },
        role: {
          $set: {},
        },
        rate: {
          $set: null,
        },
      })
    )
  }
  removePosition = pos => {
    this.setState(
      update(this.state, {
        user: {
          roles: {
            $set: this.state.user.roles.filter(r => !isEqual(r, pos)),
          },
        },
      })
    )
  }
  onPlacesChange = place => {
    this.setState(
      update(this.state, {
        location: {
          $set: place,
        },
      })
    )
    document.querySelector("#radius-input input").focus()
  }
  saveLocation = () => {
    let stateOrCountry = getStateCodeByStateName(this.state.location.state)
    if (this.state.location.country !== "United States") {
      stateOrCountry = c.getCode(this.state.location.country)
    }
    const location = {
      ...this.state.location,
      work_radius: parseInt(this.state.radius.name, 10),
      label: `${this.state.location.city}, ${stateOrCountry}`,
    }
    const existingLocation = this.props.locations.find(l => {
      if (this.state.location.country === "United States") {
        return (
          l.city === this.state.location.city &&
          l.state === this.state.location.state
        )
      } else {
        return (
          l.city === this.state.location.city &&
          l.country === this.state.location.country
        )
      }
    })
    if (existingLocation) {
      location.id = existingLocation.id
    }
    this.setState(
      update(this.state, {
        user: {
          locations: {
            $push: [location],
          },
        },
        location: {
          $set: {},
        },
        radius: {
          $set: radiusSuggestions[1],
        },
      })
    )
  }
  removeLocation = loc => {
    this.setState(
      update(this.state, {
        user: {
          locations: {
            $set: this.state.user.locations.filter(l => !isEqual(l, loc)),
          },
        },
      })
    )
  }
  handlePublicChanged = e => {
    this.setState(
      update(this.state, {
        user: {
          public: {
            $set: e.target.checked,
          },
        },
      })
    )
  }
  render() {
    const { fullScreen, classes, user } = this.props
    return (
      <Dialog
        className={classes.profileDialog}
        fullScreen={fullScreen}
        open={this.props.createUserDialogOpen}
        onClose={this.handleClose}
        onEntered={this.setUpForm}
        onExited={this.clearState}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          classes: {
            root: classes.dialogPaper,
          },
        }}
      >
        <form id="edit-form" noValidate autoComplete="off">
          <DialogTitle disableTypography className={classes.dialogTitle}>
            {!isEmpty(user) && (
              <Typography variant="h6">{`Edit ${user.first_name}`}</Typography>
            )}
            {isEmpty(user) && (
              <Typography variant="h6">{"New Crew Member"}</Typography>
            )}
            <IconButton
              className={classes.closeButton}
              onClick={this.handleClose}
              aria-label="Close"
            >
              <CloseIcon classes={{ root: classes.closeIcon }} />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="first_name">First Name *</InputLabel>
                  <Input
                    type="text"
                    fullWidth
                    name="first_name"
                    value={this.state.user.first_name}
                    onChange={this.handleInputChange}
                    onBlur={this.handleInputBlur}
                    id="first_name"
                    error={!this.fieldIsValid("first_name")}
                    autoComplete="nope"
                    inputProps={{
                      required: true,
                    }}
                  />
                  <FormHelperText error id="first_name">
                    {!this.fieldIsValid("first_name") && (
                      <span>Enter first name</span>
                    )}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="last_name">Last Name *</InputLabel>
                  <Input
                    type="text"
                    fullWidth
                    name="last_name"
                    value={this.state.user.last_name}
                    onChange={this.handleInputChange}
                    onBlur={this.handleInputBlur}
                    id="last_name"
                    error={!this.fieldIsValid("last_name")}
                    autoComplete="nope"
                    inputProps={{
                      required: true,
                    }}
                  />
                  <FormHelperText error id="last_name">
                    {!this.fieldIsValid("last_name") && (
                      <span>Enter last name</span>
                    )}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <PhoneInput
                  label="Phone *"
                  value={this.state.user.phone}
                  onChange={this.handlePhoneChange}
                  onBlur={this.handlePhoneBlur}
                  valid={this.fieldIsValid("phone")}
                  onCountryChange={this.handleCountryChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="email">
                    Email{this.state.selectedCountry !== "US" && " *"}
                  </InputLabel>
                  <Input
                    type="email"
                    fullWidth
                    name="email"
                    value={this.state.user.email}
                    onChange={this.handleInputChange}
                    onBlur={this.handleInputBlur}
                    id="email"
                    error={!this.fieldIsValid("email")}
                    autoComplete="nope"
                    inputProps={{
                      required: this.state.selectedCountry !== "US",
                    }}
                  />
                  <FormHelperText error id="email">
                    {!this.fieldIsValid("email") && <span>Enter email</span>}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
            <div className={classes.headlineWrapper}>
              <Typography variant="h5" className={classes.headline}>
                Positions
              </Typography>
            </div>

            <form onSubmit={this.savePosition} className={classes.inputWrapper}>
              <AutoComplete
                className={classNames(classes.autoComplete, {
                  [classes.marginRight]: !(
                    this.props.accessLevel === 1 &&
                    user.id !== this.props.authenticatedUser.id
                  ),
                })}
                // value={this.state.role}
                caps
                creatable={false}
                InputClasses={{
                  input: classes.autoCompleteInput,
                }}
                showValue
                placeholder="Search Position"
                onChange={val => this.onAutoCompleteChange(val, "role")}
                // suggestions={this.props.roles}
                labelKey="name"
                prop={this.props}
                value={this.state.role}
              />
              {/* <TextField
                value={this.state.rate}
                autoComplete="nope"
                id="rate-input"
                placeholder="Rate"
                type="number"
                className={classes.input}
                onChange={e => this.setState({ rate: e.target.value })}
              /> */}
              <LoadingButton
                color="primary"
                size="small"
                working={this.state.savingPosition}
                disabled={
                  isEmpty(this.state.role)
                  // ||
                  // (this.props.accessLevel === 1 &&
                  //   user.id !== this.props.authenticatedUser.id &&
                  //   !this.state.rate)
                }
                type="submit"
              >
                <AddIcon color="inherit" />
              </LoadingButton>
            </form>
            {this.state.user.roles.length > 0 && (
              <div className={classes.chipWrapper}>
                {this.state.user.roles.map(role => (
                  <PositionChip
                    key={role.id}
                    position={role.name}
                    rate={role.rate}
                    canRemove
                    onDelete={() => this.removePosition(role)}
                  />
                ))}
              </div>
            )}
            <div
              className={classNames(
                classes.headlineWrapper,
                classes.marginTop3
              )}
            >
              <Typography variant="h5" className={classes.headline}>
                Local Cities
              </Typography>
            </div>
            <div className={classes.inputWrapper}>
              <PlacesAutoComplete
                className={classes.autoComplete}
                value={this.state.location}
                InputProps={{ placeholder: "Enter City" }}
                InputClasses={{ input: classes.placesAutoCompleteInputInput }}
                onChange={this.onPlacesChange}
              />
              <AutoComplete
                id="radius-input"
                className={classNames(classes.input, classes.inputMarginBottom)}
                value={this.state.radius}
                caps
                // InputClasses={{
                //   input: classes.autoCompleteInput
                // }}
                showValue
                placeholder="Radius"
                onChange={val => {
                  this.setState({
                    radius: radiusSuggestions.find(x => x.id === val),
                  })
                }}
                defaultOptions={radiusSuggestions.map(x => {
                  x.name = x.name.toString()
                  return x
                })}
                labelKey="name"
                openMenuOnClick={true}
              />
              <LoadingButton
                color="primary"
                size="small"
                buttonclicked={this.saveLocation}
                working={this.state.savingLocation}
                disabled={
                  isEmpty(this.state.location) ||
                  (!this.state.radius ||
                    (this.state.radius && !this.state.radius.name))
                }
                type="button"
              >
                <AddIcon color="inherit" />
              </LoadingButton>
            </div>
            <div className={classes.citiesWrapper}>
              {this.state.user.locations.map(pos => (
                <MapCard
                  key={pos.id}
                  location={pos}
                  canRemove
                  onRemove={() => this.removeLocation(pos)}
                />
              ))}
            </div>
            <div
              className={classNames(
                classes.headlineWrapper,
                classes.marginTop3
              )}
            >
              <Typography variant="h5" className={classes.headline}>
                Notes
              </Typography>
            </div>
            <div className={classNames(classes.noteArea, classes.marginTop3)}>
              {this.state.user.notes.length > 0 &&
                this.state.user.notes.map((note, i) => (
                  <div
                    key={i}
                    className={classNames(classes.note, {
                      [classes.lastNote]:
                        i + 1 === this.state.user.notes.length,
                    })}
                  >
                    <div className={classes.noteContent}>
                      <div className={classes.noteFirstLine}>
                        <MessageIcon className={classes.noteMessageIcon} />
                        <Typography
                          component="p"
                          className={classes.noteLineText}
                        >
                          Note
                        </Typography>
                        <span className={classes.noteBullet}>&bull;</span>
                        <Typography
                          component="span"
                          className={classes.noteTimeAgo}
                        >
                          {Moment(note.created)
                            .utc()
                            .from(Moment())}
                        </Typography>
                      </div>
                      <Typography
                        compontent="span"
                        className={classes.noteSecondLine}
                      >
                        {this.props.authenticatedUser.first_name}{" "}
                        {this.props.authenticatedUser.last_name}
                      </Typography>
                      <Typography component="p" className={classes.noteNote}>
                        {note.note}
                      </Typography>
                    </div>
                    <CircleAvatar
                      className={classes.circleAvatar}
                      image={this.props.authenticatedUser.profile_image}
                    >
                      {this.props.authenticatedUser.first_name.charAt(0)}
                      {this.props.authenticatedUser.last_name.charAt(0)}
                    </CircleAvatar>
                  </div>
                ))}
              <div className={classes.notesInputWrapper}>
                <TextField
                  style={{ height: "400px" }}
                  value={this.state.newNote}
                  id="note-input"
                  placeholder="add note..."
                  type="text"
                  multiline
                  fullWidth
                  InputProps={{
                    classes: { underline: classes.noteInputUnderline },
                  }}
                  className={classes.noteInput}
                  onChange={e => this.setState({ newNote: e.target.value })}
                />
                <LoadingButton
                  color="primary"
                  size="small"
                  className={classes.saveNoteButton}
                  buttonclicked={this.pushNote}
                  disabled={isEmpty(this.state.newNote) || !this.state.newNote}
                  type="button"
                >
                  Add
                </LoadingButton>
              </div>
            </div>
          </DialogContent>
          <DialogActions
            className={classes.dialogActions}
            classes={{
              action: classes.dialogActionsAction,
            }}
          >
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.user.public}
                  onChange={this.handlePublicChanged}
                  color="primary"
                />
              }
              label="Public Profile"
            />
            <InfoCircle>
              Turning off Public Profile means only you and any organizations
              that have your mobile number can see your information.
            </InfoCircle>
            <LoadingButton
              color="secondary"
              className={classes.button}
              buttonclicked={this.submit}
              working={this.state.savingProfile}
              disabled={
                (!isEmpty(this.state.form) && !this.state.form.valid) ||
                this.state.savingProfile
              }
              type="button"
            >
              Save
            </LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    createUserDialogOpen: state.users.createUserDialogOpen,
    user: state.users.editUser,
    roles: state.misc.roles,
    locations: state.misc.locations,
    activeCompany: state.companies.activeCompany,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true }),
  withMobileDialog()
)(CreateUserDialog)
